import { useState } from "react";
import "./RatioPercentConverter.css"; // add a few styles if you like

export default function RatioPercentConverter() {
  /* ------------- state ------------- */
  const [ratioA, setRatioA] = useState(1);
  const [ratioB, setRatioB] = useState(1);

  /* automatic updates */
  const fractionValue = ratioB !== 0 ? ratioA / ratioB : 0;
  const percentValue   = (fractionValue * 100).toFixed(2);

  /* handlers */
  function handleFractionChange(e) {
    const val = parseFloat(e.target.value) || 0;
    // keep ratioB fixed (1) and back‑calculate A
    setRatioA(val);
    setRatioB(1);
  }

  function handlePercentChange(e) {
    const val = parseFloat(e.target.value) || 0;
    const frac = val / 100;
    setRatioA(frac);
    setRatioB(1);
  }

  /* JSX */
  return (
    <div className="rpc-box">
      <h4 style={{ marginTop: 0 }}>Ratio ⇄ Fraction ⇄ Percent Converter</h4>

      {/* ratio inputs */}
      <div className="rpc-row">
        <label>Ratio (a : b) &nbsp;</label>
        <input
          type="number"
          value={ratioA}
          onChange={e => setRatioA(parseFloat(e.target.value) || 0)}
        />
        <span style={{ margin: "0 4px" }}>:</span>
        <input
          type="number"
          value={ratioB}
          onChange={e => setRatioB(parseFloat(e.target.value) || 0)}
        />
      </div>

      {/* fraction display / edit */}
      <div className="rpc-row">
        <label>Fraction&nbsp;(a ÷ b) = </label>
        <input
          type="number"
          step="0.01"
          value={fractionValue.toFixed(2)}
          onChange={handleFractionChange}
        />
      </div>

      {/* percent display / edit */}
      <div className="rpc-row">
        <label>Percent&nbsp;(&times;100) = </label>
        <input
          type="number"
          step="0.01"
          value={percentValue}
          onChange={handlePercentChange}
        />
        <span> %</span>
      </div>
    </div>
  );
}
